//const url = 'http://52.179.248.185'
//const url = 'http://192.168.10.29'
//const url = 'http://localhost:8008';
const url = 'https://api-virtualexperience.azurewebsites.net';
const urlF = "https://www.experience-virtual.com";
const pathImg = "https://zermatinternal.com:3030/ImageUpload/UploadNN/";

export default {url, urlF, pathImg}